exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-horizontal[data-v-5542f45d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  height: 140px;\n}\n.card-image[data-v-5542f45d] {\n  width: 160px;\n  height: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.card-title[data-v-5542f45d] {\n  font-size: 110%;\n}\n.text-remark[data-v-5542f45d] {\n  font-size: 80%;\n}\n@media screen and (max-width: 700px) {\n.card-horizontal[data-v-5542f45d] {\n    height: auto;\n}\n.card-image[data-v-5542f45d] {\n    width: 100px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5542f45d","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/article/Article.vue
// module id = 2264
// module chunks = 0